export default __webpack_public_path__ + "img/bpa-logo.d9448af7.png";